import React, { useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { AutocompleteField } from "@curves/ui-base";
import { refIsRequiredError, getErrorModuleStatus } from "@util/utils";

/**
 * 店舖欄位組件
 * 用於選擇店舖
 */
const ClubField = React.forwardRef((props, ref) => {
	const { clubOptions, readOnly, errorModule = {} } = props;
	const clubRef = useRef();

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				let result = {};
				if (clubRef.current && clubRef.current.getResult) {
					result.targetClubID = clubRef.current.getResult().value;
				}
				return result;
			},
			isError: () => refIsRequiredError(clubRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<Grid xs={3} item>
			<AutocompleteField
				label="店舖名稱"
				ref={clubRef}
				options={clubOptions}
				optionKeys={["text"]}
				primaryKey="id"
				InputProps={{
					disabled: readOnly,
				}}
				fullWidth
				required
				{...getErrorModuleStatus(errorModule, "targetClubID")}
			/>
		</Grid>
	);
});

ClubField.displayName = "ClubField";

export default ClubField;

